import { List } from './List';
import { Item } from './Item';
import { Footer } from './Footer';

export const components = {
  Footer,
  Item,
  List,
};
